// 线上worker地址
// export const BASE_URL = 'https://delicate-block-8cfa.veizgenq.workers.dev'
export const BASE_URL = 'https://jsonplaceholder.typicode.com'
